import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';

const Layout = ({ children, public: isPublic, hero }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar isPublic={isPublic} onMenuClick={() => setSidebarOpen(o => !o)} />
      {hero && <div className="w-full">{hero}</div>}
      <div className="flex flex-1 relative">
        {!isPublic && (
          <>
            {/* Mobile overlay */}
            {sidebarOpen && (
              <div className="fixed inset-0 z-30 bg-black/30 lg:hidden" onClick={() => setSidebarOpen(false)} />
            )}
            {/* Sidebar */}
            <div className={`
              fixed top-0 left-0 h-full z-40 transition-transform duration-300 lg:static lg:translate-x-0 lg:z-auto
              ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            `}>
              <Sidebar onClose={() => setSidebarOpen(false)} />
            </div>
          </>
        )}
        <main className={
          isPublic
            ? 'flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6'
            : 'flex-1 p-4 sm:p-6 lg:p-8 min-w-0'
        }>
          {/* Mobile sidebar toggle for dashboard */}
          {!isPublic && (
            <button
              onClick={() => setSidebarOpen(o => !o)}
              className="lg:hidden mb-4 flex items-center gap-2 px-3 py-2 rounded-xl border border-gray-200 text-sm text-gray-600 hover:bg-gray-100 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              Menu
            </button>
          )}
          <div className="animate-fade-in">
            {children}
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
